import { createAction } from '@reduxjs/toolkit';
import type { LimitNotificationsItem } from '~/store/frontendState/limitNotifications/limitNotifications.state';

export const limitNotificationsAddItem = createAction('LIMIT_NOTIFICATIONS_ADD_ITEM', (notification: LimitNotificationsItem) => ({
  payload: {
    notification,
  },
}));

export const limitNotificationsRemoveItem = createAction('LIMIT_NOTIFICATIONS_REMOVE_ITEM', (key: string) => ({
  payload: {
    key,
  },
}));
